var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "over_layout" }, [
    _c("section", { staticClass: "upgrade" }, [
      _c(
        "a",
        {
          staticStyle: { cursor: "pointer" },
          on: {
            click: function($event) {
              return _vm.$store.commit("paymentModal", true)
            }
          }
        },
        [_vm._v(_vm._s(_vm.$store.getters.t("create_resume")))]
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "about_page" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "pages_header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _c("h2", [_vm._v(_vm._s(_vm.data.title))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "about_page_block" }, [
          _c("div", {
            staticClass: "text_area fr-view",
            domProps: { innerHTML: _vm._s(_vm.data.content) }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lines" }, [_c("h1", [_vm._v("О нас")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-773ca787", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773ca787","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/about.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-773ca787","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/about.vue
// module chunks = 0